import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// Get project progress list
export const getProjectProgressList = async () => {
    try {
        const response = await apiClient.get(`/api/project-progress-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Create project progress
export const createProjectProgressAPI = async (
    project_id: number,
    service_id: number,
    job_date: string,
    job_submission_date: string | null,
    application_submitted_date: string | null,
    decision_date: string | null,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/project-progress-create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project_id,
                service_id,
                job_date,
                job_submission_date,
                application_submitted_date,
                decision_date
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Update project progress
export const updateProjectProgressAPI = async (
    id: number,
    project_id: number,
    service_id: number,
    job_date: string,
    job_submission_date: string | null,
    application_submitted_date: string | null,
    decision_date: string | null,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/project-progress-update/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project_id,
                service_id,
                job_date,
                job_submission_date,
                application_submitted_date,
                decision_date
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Delete project progress
export const deleteProjectProgressAPI = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(
            `${baseURL}/api/project-progress-delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Change project progress status
export const changeProjectProgressStatusAPI = async (
    id: number,
    application_validated: 'Pending' | 'Validated',
    application_validated_date: string,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("application_validated", application_validated);
        formData.append("application_validated_date", application_validated_date);

        const response = await fetch(`${baseURL}/api/project-progress-status-changed/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};